module.exports = __webpack_public_path__ + "static/media/img_noPhoto.ee0781a2.png";